import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const LOCAL_K8S_LOCALSTACK = 'http://localstack:4566';
const localK8sQueue = (queueName) => `${LOCAL_K8S_LOCALSTACK}/000000000000/${queueName}`;
const LOCAL_K8S_LEGACY_MOCK_PUSH = 'http://legacy-cms-mock-server:6001/hooks/push';
const LOCAL_K8S_MINIO_CREDENTIALS = {
    accessKeyId: 'AKIAIOSFODNN7EXAMPLE',
    secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
};
const LOCAL_K8S_AWS_CREDENTIALS = {
    accessKeyId: 'testUser',
    secretAccessKey: 'testAccessKey',
};
// Add entity when the transformer is implemented and we need to enable the event consumer for it
export const importedEntities = [
    'image',
    'author',
    'gallery',
    'newsArticle',
    'videoLandingPage',
    'person',
    'multipages',
    'seoWhitelist',
    'redirect',
    'channel',
    'videoPage',
];
const definition = {
    base: {
        region: 'eu-central-1',
        sns: {
            alertQueueUrl: undefined,
            endpoint: '',
            topicArn: '',
            credentials: undefined,
        },
        aiva: {
            enabled: false,
            endpoint: '',
            xApiKey: getEnvVariableDefault('AIVA_WEB_API_KEY', ''),
            allowedIngestIds: [],
        },
        chip: {
            enabled: false,
            sqsUrl: '',
            dlqUrl: '',
            webApi: '',
            webApiUsername: getEnvVariableDefault('CHIP_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('CHIP_WEB_API_PASSWORD', ''),
            apiThrottling: false,
            vgwortLegacyPrefix: 'https://chip.met.vgwort.de/na/',
        },
        bunte: {
            enabled: false,
            sqsUrl: '',
            dlqUrl: '',
            webApi: '',
            webApiUsername: getEnvVariableDefault('BUNTE_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('BUNTE_WEB_API_PASSWORD', ''),
            apiThrottling: false,
        },
        legacyImport: {
            s3ClientConfig: {
                region: 'eu-central-1',
                forcePathStyle: false,
                credentials: undefined,
                endpoint: undefined,
            },
            sns: {
                endpoint: '',
                topicArn: '',
                credentials: undefined,
            },
            chip: {
                isConsumerEnabled: false,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    videoLandingPage: false,
                    person: false,
                    multipages: false,
                    seoWhitelist: false,
                    redirect: false,
                    channel: false,
                    videoPage: false,
                },
                sqsLocalUrl: '',
                dlqLocalUrl: '',
                sqsS3Url: '',
                dlqS3Url: '',
                sqsS3ArchiveUrl: '',
                dlqS3ArchiveUrl: '',
                defaultAuthorId: '',
                defaultJobId: '9999',
                source: 'interred',
                failNewsImportOnMissing: { image: true },
                failGalleriesImportOnMissing: { image: true },
                bucket: {
                    bucketName: '',
                    archiveBucketName: '',
                },
            },
            bunte: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    videoLandingPage: false,
                    person: false,
                    multipages: false,
                    seoWhitelist: false,
                    redirect: false,
                    channel: false,
                    videoPage: false,
                },
                sqsLocalUrl: '',
                dlqLocalUrl: '',
                sqsS3Url: '',
                dlqS3Url: '',
                sqsS3ArchiveUrl: '',
                dlqS3ArchiveUrl: '',
                defaultAuthorId: '',
                defaultJobId: '',
                source: 'bunte-stack',
                failNewsImportOnMissing: { image: true },
                failGalleriesImportOnMissing: { image: true },
                bucket: {
                    bucketName: '',
                    archiveBucketName: '',
                },
            },
            focus: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    videoLandingPage: false,
                    person: false,
                    multipages: false,
                    seoWhitelist: false,
                    redirect: false,
                    channel: false,
                    videoPage: false,
                },
                sqsLocalUrl: '',
                dlqLocalUrl: '',
                sqsS3Url: '',
                dlqS3Url: '',
                sqsS3ArchiveUrl: '',
                dlqS3ArchiveUrl: '',
                defaultAuthorId: '659f7f7f-92d2-4952-ab0e-9cbbeba35b5b',
                defaultJobId: '0001',
                source: 'escenic',
                failNewsImportOnMissing: { image: true },
                failGalleriesImportOnMissing: { image: true },
                bucket: {
                    bucketName: '',
                    archiveBucketName: '',
                },
                awsImageBucketName: '',
            },
            praxistipps: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    videoLandingPage: false,
                    person: false,
                    multipages: false,
                    seoWhitelist: false,
                    redirect: false,
                    channel: false,
                    videoPage: false,
                },
                sqsLocalUrl: '',
                dlqLocalUrl: '',
                sqsS3Url: '',
                dlqS3Url: '',
                sqsS3ArchiveUrl: '',
                dlqS3ArchiveUrl: '',
                defaultAuthorId: '',
                defaultJobId: '0007',
                source: 'praxistipps',
                failNewsImportOnMissing: { image: true },
                failGalleriesImportOnMissing: { image: true },
                bucket: {
                    bucketName: '',
                    archiveBucketName: '',
                },
            },
        },
    },
    test: {
        sns: {
            alertQueueUrl: undefined,
            endpoint: 'http://localhost:4566',
            topicArn: 'arn:aws:sns:eu-central-1:000000000000:contentEvents',
        },
        legacyImport: {
            sns: {
                endpoint: 'http://localhost:4566',
                topicArn: 'arn:aws:sns:eu-central-1:000000000000:importEvents',
            },
            bunte: {
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    person: true,
                    seoWhitelist: true,
                    redirect: true,
                    channel: true,
                },
                failNewsImportOnMissing: { image: false },
            },
            chip: {
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoPage: true,
                },
            },
            focus: {
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoLandingPage: true,
                    multipages: true,
                },
            },
        },
    },
    local: {
        sns: {
            alertQueueUrl: undefined,
            endpoint: 'http://localhost:4566',
            topicArn: 'arn:aws:sns:eu-central-1:000000000000:contentEvents',
            credentials: {
                accessKeyId: 'testUser',
                secretAccessKey: 'testAccessKey',
            },
        },
        bunte: {
            sqsUrl: 'http://localhost:4566/000000000000/bunteEventsQueue',
            dlqUrl: 'http://localhost:4566/000000000000/bunteEventsDLQueue',
            webApi: 'http://localhost:6001/hooks/push',
        },
        chip: {
            enabled: true,
            sqsUrl: 'http://localhost:4566/000000000000/chipEventsQueue',
            dlqUrl: 'http://localhost:4566/000000000000/chipEventsDLQueue',
            webApi: 'http://localhost:6001/hooks/push',
        },
        legacyImport: {
            sns: {
                endpoint: 'http://localhost:4566',
                topicArn: 'arn:aws:sns:eu-central-1:000000000000:importEvents',
                credentials: {
                    accessKeyId: 'testUser',
                    secretAccessKey: 'testAccessKey',
                },
            },
            s3ClientConfig: {
                endpoint: 'https://local-s3.burda-forward.de:443',
                forcePathStyle: true,
                credentials: {
                    // Local MinIO Credentials
                    accessKeyId: 'AKIAIOSFODNN7EXAMPLE',
                    secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
                },
            },
            bunte: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    person: true,
                    redirect: true,
                    channel: true,
                },
                sqsLocalUrl: 'http://localhost:4566/000000000000/bunteImportEventsQueue',
                dlqLocalUrl: 'http://localhost:4566/000000000000/bunteImportEventsDLQueue',
                sqsS3Url: 'http://localhost:4566/000000000000/bunteImportS3EventsQueue',
                dlqS3Url: 'http://localhost:4566/000000000000/bunteImportS3EventsDLQueue',
                sqsS3ArchiveUrl: 'http://localhost:4566/000000000000/bunteImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localhost:4566/000000000000/bunteImportS3ArchiveEventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-bunte-local',
                    archiveBucketName: 'ctf-legacy-import-archive-bunte-local',
                },
            },
            chip: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoPage: true,
                },
                sqsLocalUrl: 'http://localhost:4566/000000000000/chipImportEventsQueue',
                dlqLocalUrl: 'http://localhost:4566/000000000000/chipImportEventsDLQueue',
                sqsS3Url: 'http://localhost:4566/000000000000/chipImportS3EventsQueue',
                dlqS3Url: 'http://localhost:4566/000000000000/chipImportS3EventsDLQueue',
                sqsS3ArchiveUrl: 'http://localhost:4566/000000000000/chipImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localhost:4566/000000000000/chipImportS3ArchiveEventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-chip-local',
                    archiveBucketName: 'ctf-legacy-import-archive-chip-local',
                },
            },
            focus: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoLandingPage: true,
                    multipages: true,
                },
                sqsLocalUrl: 'http://localhost:4566/000000000000/focusImportEventsQueue',
                dlqLocalUrl: 'http://localhost:4566/000000000000/focusImportEventsDLQueue',
                sqsS3Url: 'http://localhost:4566/000000000000/focusImportS3EventsQueue',
                dlqS3Url: 'http://localhost:4566/000000000000/focusImportS3EventsDLQueue',
                sqsS3ArchiveUrl: 'http://localhost:4566/000000000000/focusImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localhost:4566/000000000000/focusImportS3ArchiveEventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-focus-local',
                    archiveBucketName: 'ctf-legacy-import-archive-focus-local',
                },
                awsImageBucketName: '',
            },
            praxistipps: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    newsArticle: true,
                },
                sqsLocalUrl: 'http://localhost:4566/000000000000/praxistippsImportEventsQueue',
                dlqLocalUrl: 'http://localhost:4566/000000000000/praxistippsImportEventsDLQueue',
                sqsS3Url: 'http://localhost:4566/000000000000/praxistippsImportS3EventsQueue',
                dlqS3Url: 'http://localhost:4566/000000000000/praxistippsImportS3EventsDLQueue',
                sqsS3ArchiveUrl: 'http://localhost:4566/000000000000/praxistippsImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localhost:4566/000000000000/praxistippsImportS3ArchiveEventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-praxistipps-local',
                    archiveBucketName: 'ctf-legacy-import-archive-praxistipps-local',
                },
            },
        },
    },
    local_k8s: {
        sns: {
            alertQueueUrl: undefined,
            endpoint: LOCAL_K8S_LOCALSTACK,
            topicArn: 'arn:aws:sns:eu-central-1:000000000000:contentEvents',
            credentials: LOCAL_K8S_AWS_CREDENTIALS,
        },
        bunte: {
            sqsUrl: localK8sQueue('bunteEventsQueue'),
            dlqUrl: localK8sQueue('bunteEventsDLQueue'),
            webApi: LOCAL_K8S_LEGACY_MOCK_PUSH,
        },
        chip: {
            enabled: true,
            sqsUrl: localK8sQueue('chipEventsQueue'),
            dlqUrl: localK8sQueue('chipEventsDLQueue'),
            webApi: LOCAL_K8S_LEGACY_MOCK_PUSH,
        },
        legacyImport: {
            sns: {
                endpoint: LOCAL_K8S_LOCALSTACK,
                topicArn: 'arn:aws:sns:eu-central-1:000000000000:importEvents',
                credentials: LOCAL_K8S_AWS_CREDENTIALS,
            },
            s3ClientConfig: {
                endpoint: 'http://s3-local:9002',
                forcePathStyle: true,
                credentials: LOCAL_K8S_MINIO_CREDENTIALS,
            },
            bunte: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    person: true,
                    redirect: true,
                    channel: true,
                },
                sqsLocalUrl: localK8sQueue('bunteImportEventsQueue'),
                dlqLocalUrl: localK8sQueue('bunteImportEventsDLQueue'),
                sqsS3Url: localK8sQueue('bunteImportS3EventsQueue'),
                dlqS3Url: localK8sQueue('bunteImportS3EventsDLQueue'),
                sqsS3ArchiveUrl: localK8sQueue('bunteImportS3ArchiveEventsQueue'),
                dlqS3ArchiveUrl: localK8sQueue('bunteImportS3ArchiveEventsDLQueue'),
                bucket: {
                    bucketName: 'ctf-legacy-import-bunte-local',
                    archiveBucketName: 'ctf-legacy-import-archive-bunte-local',
                },
            },
            chip: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoPage: true,
                },
                sqsLocalUrl: localK8sQueue('chipImportEventsQueue'),
                dlqLocalUrl: localK8sQueue('chipImportEventsDLQueue'),
                sqsS3Url: localK8sQueue('chipImportS3EventsQueue'),
                dlqS3Url: localK8sQueue('chipImportS3EventsDLQueue'),
                sqsS3ArchiveUrl: localK8sQueue('chipImportS3ArchiveEventsQueue'),
                dlqS3ArchiveUrl: localK8sQueue('chipImportS3ArchiveEventsDLQueue'),
                bucket: {
                    bucketName: 'ctf-legacy-import-chip-local',
                    archiveBucketName: 'ctf-legacy-import-archive-chip-local',
                },
            },
            focus: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoLandingPage: true,
                    multipages: true,
                },
                sqsLocalUrl: localK8sQueue('focusImportEventsQueue'),
                dlqLocalUrl: localK8sQueue('focusImportEventsDLQueue'),
                sqsS3Url: localK8sQueue('focusImportS3EventsQueue'),
                dlqS3Url: localK8sQueue('focusImportS3EventsDLQueue'),
                sqsS3ArchiveUrl: localK8sQueue('focusImportS3ArchiveEventsQueue'),
                dlqS3ArchiveUrl: localK8sQueue('focusImportS3ArchiveEventsDLQueue'),
                bucket: {
                    bucketName: 'ctf-legacy-import-focus-local',
                    archiveBucketName: 'ctf-legacy-import-archive-focus-local',
                },
                awsImageBucketName: '',
            },
            praxistipps: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    newsArticle: true,
                },
                sqsLocalUrl: localK8sQueue('praxistippsImportEventsQueue'),
                dlqLocalUrl: localK8sQueue('praxistippsImportEventsDLQueue'),
                sqsS3Url: localK8sQueue('praxistippsImportS3EventsQueue'),
                dlqS3Url: localK8sQueue('praxistippsImportS3EventsDLQueue'),
                sqsS3ArchiveUrl: localK8sQueue('praxistippsImportS3ArchiveEventsQueue'),
                dlqS3ArchiveUrl: localK8sQueue('praxistippsImportS3ArchiveEventsDLQueue'),
                bucket: {
                    bucketName: 'ctf-legacy-import-praxistipps-local',
                    archiveBucketName: 'ctf-legacy-import-archive-praxistipps-local',
                },
            },
        },
    },
    local_e2e: {
        sns: {
            alertQueueUrl: undefined,
            endpoint: 'http://localstack:4566',
            topicArn: 'arn:aws:sns:eu-central-1:000000000000:contentEvents',
            credentials: {
                accessKeyId: 'testUser',
                secretAccessKey: 'testAccessKey',
            },
        },
        bunte: {
            sqsUrl: 'http://localstack:4566/000000000000/bunteEventsQueue',
            dlqUrl: 'http://localstack:4566/000000000000/bunteEventsDLQueue',
            webApi: 'http://localhost:6001/hooks/push',
        },
        chip: {
            enabled: true,
            sqsUrl: 'http://localstack:4566/000000000000/chipEventsQueue',
            dlqUrl: 'http://localstack:4566/000000000000/chipEventsDLQueue',
            webApi: 'http://localhost:6001/hooks/push',
        },
        legacyImport: {
            sns: {
                endpoint: 'http://localhost:4566',
                topicArn: 'arn:aws:sns:eu-central-1:000000000000:importEvents',
                credentials: {
                    accessKeyId: 'testUser',
                    secretAccessKey: 'testAccessKey',
                },
            },
            s3ClientConfig: {
                endpoint: 'https://local-s3.burda-forward.de:443',
                forcePathStyle: true,
                credentials: {
                    // Local MinIO Credentials
                    accessKeyId: 'AKIAIOSFODNN7EXAMPLE',
                    secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
                },
            },
            bunte: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    person: true,
                    redirect: true,
                    channel: true,
                },
                sqsS3Url: 'http://localstack:4566/000000000000/bunteImportS3EventsQueue',
                dlqS3Url: 'http://localstack:4566/000000000000/bunteImportS3EventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-bunte-local',
                    archiveBucketName: 'ctf-legacy-import-archive-bunte-local',
                },
                sqsS3ArchiveUrl: 'http://localstack:4566/000000000000/bunteImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localstack:4566/000000000000/bunteImportS3ArchiveEventsDLQueue',
            },
            chip: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoPage: true,
                },
                sqsS3Url: 'http://localstack:4566/000000000000/chipImportS3EventsQueue',
                dlqS3Url: 'http://localstack:4566/000000000000/chipImportS3EventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-chip-local',
                    archiveBucketName: 'ctf-legacy-import-archive-chip-local',
                },
                sqsS3ArchiveUrl: 'http://localstack:4566/000000000000/chipImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localstack:4566/000000000000/chipImportS3ArchiveEventsDLQueue',
            },
            focus: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoLandingPage: true,
                    multipages: true,
                },
                sqsS3Url: 'http://localstack:4566/000000000000/focusImportS3EventsQueue',
                dlqS3Url: 'http://localstack:4566/000000000000/focusImportS3EventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-focus-local',
                    archiveBucketName: 'ctf-legacy-import-archive-focus-local',
                },
                awsImageBucketName: '',
                sqsS3ArchiveUrl: 'http://localstack:4566/000000000000/focusImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localstack:4566/000000000000/focusImportS3ArchiveEventsDLQueue',
            },
            praxistipps: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                },
                sqsS3Url: 'http://localstack:4566/000000000000/praxistippsImportS3EventsQueue',
                dlqS3Url: 'http://localstack:4566/000000000000/praxistippsImportS3EventsDLQueue',
                bucket: {
                    bucketName: 'ctf-legacy-import-praxistipps-local',
                    archiveBucketName: 'ctf-legacy-import-archive-praxistipps-local',
                },
                sqsS3ArchiveUrl: 'http://localstack:4566/000000000000/praxistippsImportS3ArchiveEventsQueue',
                dlqS3ArchiveUrl: 'http://localstack:4566/000000000000/praxistippsImportS3ArchiveEventsDLQueue',
            },
        },
    },
    sandbox: {
        sns: {
            alertQueueUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/legacy_push_alerts_queue${getEnvVariableDefault('BRANCH_SANDBOX_NAME', '')}`,
            endpoint: undefined,
            topicArn: getEnvVariableDefault('SNS_TOPIC_ARN', ''),
        },
        chip: {
            enabled: true,
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('CHIP_EVENTS_QUEUE_NAME', 'chip_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('CHIP_EVENTS_DLQUEUE_NAME', 'chip_events_dlqueue')}`,
            webApi: 'https://legacy-cms-mock-server.k8s-main.bf-ctf-sandbox.aws.bfops.io/hooks/push',
            webApiUsername: getEnvVariableDefault('CHIP_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('CHIP_WEB_API_PASSWORD', ''),
        },
        bunte: {
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('BUNTE_EVENTS_QUEUE_NAME', 'bunte_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('BUNTE_EVENTS_DLQUEUE_NAME', 'bunte_events_dlqueue')}`,
            webApi: 'https://legacy-cms-mock-server.k8s-main.bf-ctf-sandbox.aws.bfops.io/hooks/push',
            webApiUsername: getEnvVariableDefault('BUNTE_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('BUNTE_WEB_API_PASSWORD', ''),
        },
        legacyImport: {
            sns: {
                endpoint: undefined,
                topicArn: getEnvVariableDefault('SNS_IMPORT_TOPIC_ARN', ''),
            },
            chip: {
                isConsumerEnabled: false,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    videoPage: false,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-chip-sandbox',
                    archiveBucketName: 'ctf-legacy-import-archive-chip-sandbox',
                },
            },
            bunte: {
                isConsumerEnabled: false,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    person: false,
                    seoWhitelist: false,
                    redirect: false,
                    channel: false,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-bunte-sandbox',
                    archiveBucketName: 'ctf-legacy-import-archive-bunte-sandbox',
                },
            },
            focus: {
                isConsumerEnabled: false,
                isEntityTransformerEnabled: {
                    image: false,
                    author: false,
                    gallery: false,
                    newsArticle: false,
                    videoLandingPage: false,
                    multipages: false,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-focus-sandbox',
                    archiveBucketName: 'ctf-legacy-import-archive-focus-sandbox',
                },
                awsImageBucketName: '628227924881-eu-central-1-escenic-binaries', // Focus DEV
            },
            praxistipps: {
                isConsumerEnabled: false,
                isEntityTransformerEnabled: {
                    image: false,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/757726966663/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-praxistipps-sandbox',
                    archiveBucketName: 'ctf-legacy-import-archive-praxistipps-sandbox',
                },
            },
        },
    },
    development: {
        sns: {
            alertQueueUrl: 'https://sqs.eu-central-1.amazonaws.com/727602533799/legacy_push_alerts_queue',
            endpoint: undefined,
            topicArn: getEnvVariableDefault('SNS_TOPIC_ARN', ''),
        },
        aiva: {
            enabled: true,
            endpoint: 'https://video-automation.bf-autovideo-development.aws.bfops.io/backend/ctfVideoCreated',
            xApiKey: getEnvVariableDefault('AIVA_WEB_API_KEY', ''),
            allowedIngestIds: ['D2b94CrK'],
        },
        chip: {
            enabled: true,
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('CHIP_EVENTS_QUEUE_NAME', 'chip_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('CHIP_EVENTS_DLQUEUE_NAME', 'chip_events_dlqueue')}`,
            webApi: 'https://stg-chip-webapi.chip.de/webhook/listener',
            webApiUsername: getEnvVariableDefault('CHIP_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('CHIP_WEB_API_PASSWORD', ''),
        },
        bunte: {
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('BUNTE_EVENTS_QUEUE_NAME', 'bunte_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('BUNTE_EVENTS_DLQUEUE_NAME', 'bunte_events_dlqueue')}`,
            webApi: 'https://admin-api-develop.bunte.de/webhook/ctf',
            webApiUsername: getEnvVariableDefault('BUNTE_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('BUNTE_WEB_API_PASSWORD', ''),
        },
        legacyImport: {
            sns: {
                endpoint: undefined,
                topicArn: getEnvVariableDefault('SNS_IMPORT_TOPIC_ARN', ''),
            },
            chip: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoPage: true,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-chip-development',
                    archiveBucketName: 'ctf-legacy-import-archive-chip-development',
                },
            },
            bunte: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    person: true,
                    seoWhitelist: true,
                    redirect: true,
                    channel: true,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-bunte-development',
                    archiveBucketName: 'ctf-legacy-import-archive-bunte-development',
                },
                failNewsImportOnMissing: { image: false },
                failGalleriesImportOnMissing: { image: false },
            },
            focus: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoLandingPage: true,
                    multipages: true,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-focus-development',
                    archiveBucketName: 'ctf-legacy-import-archive-focus-development',
                },
                failNewsImportOnMissing: { image: false },
                failGalleriesImportOnMissing: { image: false },
                awsImageBucketName: '396371736508-eu-central-1-escenic-binaries', // Focus STG
            },
            praxistipps: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    newsArticle: true,
                },
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/727602533799/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-praxistipps-development',
                    archiveBucketName: 'ctf-legacy-import-archive-praxistipps-development',
                },
            },
        },
    },
    staging: {
        sns: {
            alertQueueUrl: 'https://sqs.eu-central-1.amazonaws.com/833612680673/legacy_push_alerts_queue',
            endpoint: undefined,
            topicArn: getEnvVariableDefault('SNS_TOPIC_ARN', ''),
        },
        chip: {
            enabled: true,
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('CHIP_EVENTS_QUEUE_NAME', 'chip_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('CHIP_EVENTS_DLQUEUE_NAME', 'chip_events_dlqueue')}`,
            webApi: 'https://legacy-cms-mock-server.k8s-main.bf-ctf-staging.aws.bfops.io/hooks/push',
            webApiUsername: getEnvVariableDefault('CHIP_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('CHIP_WEB_API_PASSWORD', ''),
        },
        bunte: {
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('BUNTE_EVENTS_QUEUE_NAME', 'bunte_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('BUNTE_EVENTS_DLQUEUE_NAME', 'bunte_events_dlqueue')}`,
            webApi: 'https://legacy-cms-mock-server.k8s-main.bf-ctf-staging.aws.bfops.io/hooks/push',
            webApiUsername: getEnvVariableDefault('BUNTE_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('BUNTE_WEB_API_PASSWORD', ''),
        },
        legacyImport: {
            sns: {
                endpoint: undefined,
                topicArn: getEnvVariableDefault('SNS_IMPORT_TOPIC_ARN', ''),
            },
            chip: {
                isConsumerEnabled: true,
                defaultJobId: '0001',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_archive_events_dlqueue')}`,
            },
            bunte: {
                isConsumerEnabled: true,
                defaultJobId: '',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_s3_archive_events_dlqueue')}`,
            },
            focus: {
                isConsumerEnabled: true,
                defaultAuthorId: '5c81a405-9556-4891-969c-ed6841f771ff',
                defaultJobId: '0001',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_archive_events_dlqueue')}`,
            },
            praxistipps: {
                isConsumerEnabled: true,
                defaultJobId: '',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/833612680673/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_dlqueue')}`,
            },
        },
    },
    production: {
        sns: {
            alertQueueUrl: 'https://sqs.eu-central-1.amazonaws.com/885151169647/legacy_push_alerts_queue',
            endpoint: undefined,
            topicArn: getEnvVariableDefault('SNS_TOPIC_ARN', ''),
        },
        chip: {
            enabled: true,
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('CHIP_EVENTS_QUEUE_NAME', 'chip_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('CHIP_EVENTS_DLQUEUE_NAME', 'chip_events_dlqueue')}`,
            webApi: 'https://prd-chip-webapi.chip.de/webhook/listener',
            webApiUsername: getEnvVariableDefault('CHIP_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('CHIP_WEB_API_PASSWORD', ''),
        },
        bunte: {
            sqsUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('BUNTE_EVENTS_QUEUE_NAME', 'bunte_events_queue')}`,
            dlqUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('BUNTE_EVENTS_DLQUEUE_NAME', 'bunte_events_dlqueue')}`,
            webApi: 'https://admin-api.bunte.de/webhook/ctf',
            webApiUsername: getEnvVariableDefault('BUNTE_WEB_API_USERNAME', ''),
            webApiPassword: getEnvVariableDefault('BUNTE_WEB_API_PASSWORD', ''),
        },
        legacyImport: {
            sns: {
                endpoint: undefined,
                topicArn: getEnvVariableDefault('SNS_IMPORT_TOPIC_ARN', ''),
            },
            chip: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoPage: true,
                },
                defaultJobId: '0001',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'chip_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('CHIP_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'chip_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-chip-production',
                    archiveBucketName: 'ctf-legacy-import-archive-chip-production',
                },
            },
            bunte: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    person: true,
                    seoWhitelist: true,
                    redirect: true,
                    channel: true,
                },
                defaultJobId: '',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'bunte_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('BUNTE_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'bunte_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-bunte-production',
                    archiveBucketName: 'ctf-legacy-import-archive-bunte-production',
                },
                failNewsImportOnMissing: { image: false },
                failGalleriesImportOnMissing: { image: false },
            },
            focus: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    gallery: true,
                    newsArticle: true,
                    videoLandingPage: true,
                    multipages: true,
                },
                defaultAuthorId: 'c0cc803d-47ab-45b7-b037-de03edd4e58a',
                defaultJobId: '0001',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'focus_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('FOCUS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'focus_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-focus-production',
                    archiveBucketName: 'ctf-legacy-import-archive-focus-production',
                },
                awsImageBucketName: '003925032491-eu-central-1-escenic-binaries', // Focus PROD
            },
            praxistipps: {
                isConsumerEnabled: true,
                isEntityTransformerEnabled: {
                    image: true,
                    author: true,
                    newsArticle: true,
                },
                defaultJobId: '',
                sqsS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_events_queue')}`,
                dlqS3Url: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_events_dlqueue')}`,
                sqsS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_QUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_queue')}`,
                dlqS3ArchiveUrl: `https://sqs.eu-central-1.amazonaws.com/885151169647/${getEnvVariableDefault('PRAXISTIPPS_LEGACY_IMPORT_S3_ARCHIVE_EVENTS_DLQUEUE_NAME', 'praxistipps_legacy_import_s3_archive_events_dlqueue')}`,
                bucket: {
                    bucketName: 'ctf-legacy-import-praxistipps-production',
                    archiveBucketName: 'ctf-legacy-import-archive-praxistipps-production',
                },
            },
        },
    },
};
export const legacyConsumerConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=legacyConsumer.config.js.map